export var ErrorType;
(function (ErrorType) {
    ErrorType["INTERNAL"] = "-1";
    ErrorType["FOLIO_EXTERNAL_OR_UNDEFINED"] = "-2";
    ErrorType["EXTERNAL_OR_UNDEFINED"] = "-3";
    ErrorType["UNKNOWN"] = "-4";
    ErrorType["PUBLISHER_PREFIX_MAGNITUDE_INVALID"] = "-5";
    ErrorType["PUBLISHER_PREFIX_END_NUMBER_LENGTH_INVALID"] = "-6";
    ErrorType["PUBLISHER_PREFIX_RANGE_END_IN_ANOTHER_RANGE"] = "-7";
    ErrorType["PUBLISHER_PREFIX_RANGE_END_BEFORE_START"] = "-8";
    ErrorType["PUBLISHER_PREFIX_RANGE_OVERLAPS_ANOTHER_RANGE"] = "-9";
    ErrorType["PUBLISHER_PREFIX_ALREADY_ASSIGNED"] = "-10";
    ErrorType["PUBLISHER_PREFIX_START_NUMBER_LENGTH_INVALID"] = "-11";
    ErrorType["PUBLISHER_PREFIX_RANGE_START_IN_ANOTHER_RANGE"] = "-12";
    ErrorType["CANNOT_CREATE_PREFIX_FOR_CLOSING_PUBLISHER"] = "-17";
    ErrorType["NO_ACTIVE_PUBLISHER_PREFIX_RANGES"] = "-23";
    /** No product number can be drawn and the cause is unknown (no new prefix size was given, RCK-1685). */
    ErrorType["NO_AVAILABLE_PRODUCT_NUMBER"] = "-24";
    ErrorType["TITLE_CONTRIBUTION_NAME_REQUIRED"] = "-30";
    ErrorType["TITLE_CONTRIBUTION_PERSON_XOR_UNNAMED"] = "-31";
    ErrorType["ONE_OFF_PUBLISHER_CANNOT_CREATE_TITLE"] = "-34";
    ErrorType["NO_AVAILABLE_PUBLISHER_PREFIX_VALUES"] = "-37";
    ErrorType["CANNOT_TRANSFER_INACTIVE_PREFIX"] = "-39";
    ErrorType["CANNOT_TRANSFER_PREFIX_TO_CLOSED_PUBLISHER"] = "-40";
    ErrorType["CANNOT_TRANSFER_PREFIX_TO_SAME_PUBLISHER"] = "-41";
    ErrorType["PRODUCT_NOT_OWNED_BY_GUARANTOR"] = "-25";
    ErrorType["TITLE_HAS_PRODUCTS"] = "-44";
    ErrorType["LAST_USED_NUMBER_INVALID"] = "-53";
    ErrorType["LAST_USED_NUMBER_NOT_IN_PREFIX"] = "-54";
    ErrorType["PREFIX_DECLARATION_PENDING"] = "-55";
    ErrorType["DECLARATION_NOT_ALLOWED"] = "-56";
    ErrorType["MAIN_TITLE_EXACTLY_ONE"] = "-58";
    ErrorType["PRODUCT_HAS_NUMBER"] = "-64";
    ErrorType["PRODUCT_DELETE_NOT_ALLOWED"] = "-65";
    ErrorType["PRODUCT_NUMBER_RETIRED"] = "-66";
    ErrorType["PRODUCT_DELETED_BLOCK_REASON_NOT_ALLOWED"] = "-67";
    ErrorType["NATURAL_PERSON_BIOGRAPHICAL_NOTE_REQUIRED"] = "-68";
    ErrorType["ONE_OFF_PUBLISHER_CANNOT_CREATE_PRODUCT"] = "-70";
    ErrorType["TITLE_SUPPORTING_RESOURCE_IMAGE_MODE_REQUIRED"] = "-71";
    ErrorType["TITLE_SUPPORTING_RESOURCE_IMAGE_LINK_INVALID"] = "-72";
    ErrorType["PUBLISHER_PREFIX_MAGNITUDE_NOT_ALLOWED"] = "-78";
    ErrorType["PERSON_AUTHORITY_LINK_REQUIRES_AGENCY_WORKER"] = "-79";
    ErrorType["PERSON_ALREADY_LINKED_TO_AUTHORITY"] = "-80";
    ErrorType["PERSON_AUTHORITY_ID_DUPLICATE"] = "-81";
    ErrorType["PERSON_AUTHORITY_ID_REQUIRED"] = "-82";
    ErrorType["PERSON_MERGE_INVALID_TARGET"] = "-83";
    ErrorType["PERSON_ALREADY_SENT_TO_AUTHORITY"] = "-84";
    ErrorType["PERSON_MERGE_INVALID_SOURCE"] = "-86";
    ErrorType["TITLE_SUBJECT_THEMA_QUALIFIER_REQUIRES_CATEGORY"] = "-87";
    ErrorType["TITLE_SUPPORTING_RESOURCE_PDF_LINK_INVALID"] = "-88";
    ErrorType["STORAGE_UPLOAD_VIRUS_FOUND"] = "-89";
    ErrorType["STORAGE_ANTIVIRUS_UNAVAILABLE"] = "-90";
    ErrorType["PERSON_MERGE_PROPOSAL_NOT_LINKED_TO_AUTHORITY"] = "-91";
    /** A public-only caller (e.g. Distributor) filtered or sorted by agency-internal data (DB-837). */
    ErrorType["FILTER_NOT_ALLOWED_FOR_PUBLIC_ONLY_VIEW"] = "-92";
    /** A keyword (20) or Thema qualifier (94–99) subject was sent as the main subject (issue #76113). */
    ErrorType["TITLE_SUBJECT_MAIN_NOT_ALLOWED"] = "-94";
    /** A subject scheme was sent with more than one main subject (issue #76113). */
    ErrorType["TITLE_SUBJECT_MULTIPLE_MAIN_IN_SCHEME"] = "-95";
    /** A new publisher prefix is needed and only the publisher itself may create it (Tools #76358). */
    ErrorType["NEW_PREFIX_BY_PUBLISHER_ONLY"] = "-99";
    /** The remaining free numbers are reserved by another assignment in progress (RCK-1667). */
    ErrorType["PRODUCT_NUMBERS_RESERVED"] = "-100";
    /** The publisher is in liquidation and has no free number (RCK-1667). */
    ErrorType["PUBLISHER_CLOSING_NO_FREE_NUMBER"] = "-101";
    /** No free number and no free agency prefix range for a new prefix (RCK-1667). */
    ErrorType["NO_FREE_PUBLISHER_PREFIX_RANGE"] = "-102";
    /** No free number could be drawn from the publisher prefix (RCK-1667). */
    ErrorType["PUBLISHER_PREFIX_NO_FREE_NUMBER"] = "-103";
    /** No agency prefix is configured for the registration agency (RCK-1667). */
    ErrorType["NO_AGENCY_PREFIX"] = "-104";
    /** The prefix's free numbers are being assigned concurrently right now; retry (RCK-1667). */
    ErrorType["PRODUCT_NUMBER_ASSIGNMENT_IN_PROGRESS"] = "-105";
    /** Several agency prefixes and none chosen; choose it on the assign page (RCK-1667). */
    ErrorType["AGENCY_PREFIX_CHOICE_REQUIRED"] = "-106";
    /** The chosen publisher prefix has no free number left (RCK-1667). */
    ErrorType["CHOSEN_PUBLISHER_PREFIX_NO_FREE_NUMBER"] = "-107";
    ErrorType["DECLARATION_NOT_DECLARED"] = "-108";
})(ErrorType || (ErrorType = {}));
export var getErrorTypeCode = function (errorType) {
    return errorType;
};
